import React, {Component} from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Navbar,Nav,NavDropdown,Form,FormControl,Button, Image } from 'react-bootstrap'
import logo from '../../media/logo.png'
import { signOut } from '../../actions/generic/authActions';
import {getAbp} from '../../storage/sessionStorage';

class TopMenu extends Component {
  state = {
    current: 'home',
  };


  handleClick = e => {
    console.log('click ', e);
    this.setState({ current: e.key });
  };

  renderMenuItem(item){
    if (item.items.length > 0){
      return (
        <NavDropdown key={item.name} title={item.displayName} id="basic-nav-dropdown">
          {item.items.map(x => {
            return <NavDropdown.Item key = {x.name} href={x.url}>{(!_.isEmpty(x.icon)) && <i className={x.icon}></i>}{' ' + x.displayName}</NavDropdown.Item>
          })}
        </NavDropdown>
      )
    }
    else{
      return (<Nav.Link key={item.name} href={item.url}>{item.displayName} </Nav.Link>);
    }
  }

  hardCodedSampleMenu() {
    return (
          <Navbar className="fs-6" bg="primary" variant="dark" expand="lg" sticky="top">
            <Navbar.Brand><Image height='30' src={logo}/></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                <Nav.Link href="/">Home</Nav.Link>
                <Nav.Link href="/about-us">Contact Us</Nav.Link>
                <Nav.Link href="/contact-us">About Us</Nav.Link>
                <NavDropdown title="Dropdown" id="basic-nav-dropdown">
                    <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                    <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
                    <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
                </NavDropdown>
                </Nav>
                <Nav className="navbar-right">
                  <NavDropdown title={(<span><i className="fa fa-user"/> {`${this.props.auth.user.name} ${this.props.auth.user.surname}`}</span>)} id="user-dropdown">
                      <NavDropdown.Item href={`${window.location.origin}${window.location.pathname}#/profile`} eventKey='1'><i className="fa fa-envelope fa-fw"></i> User Profile</NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item onClick={() => this.props.signOut()}><i className="fa fa-sign-out-alt fa-fw"></i> Logout</NavDropdown.Item>
                  </NavDropdown>
                </Nav>
            </Navbar.Collapse>
          </Navbar>
    );
  }

  render() {
    const { current } = this.state;
    return (
      //this.hardCodedSampleMenu()
      <Navbar className="fs-6" bg="primary-light" variant="light" expand="lg" sticky="top" >
      <Navbar.Brand><Image height='30' src={logo}/></Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
             {getAbp().MainMenu.items.map(x => {return this.renderMenuItem(x)})}
           </Nav>
           <Nav className="navbar-right">
             <NavDropdown title={(<span><i className="fa fa-user"/> {`${this.props.auth.user.name} ${this.props.auth.user.surname}`}</span>)} id="user-dropdown">
                 <NavDropdown.Item  href={`${window.location.origin}${window.location.pathname}#/profile`} key={"/profile"} eventKey='1'><i className="fa fa-cog fa-fw"></i> User Profile</NavDropdown.Item>
                 <NavDropdown.Divider />
                 <NavDropdown.Item onClick={() => this.props.signOut()}><i className="fa fa-sign-out-alt fa-fw"></i> Logout</NavDropdown.Item>
             </NavDropdown>
           </Nav>
       </Navbar.Collapse>
     </Navbar>
    );
  }
}

const mapStateToProps = (state) => {
  return{
      auth: state.auth
  };
}

export default connect(
  // map state to props
  mapStateToProps, 
  // map dispatch to props
  (dispatch, ownProps) => ({
    //signOut
      signOut: () => dispatch(signOut()),
    })
  )(TopMenu);

